import { useEffect } from "react";
import FHIR from "fhirclient";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  handleFhirInitializationFailure,
  initializeFhirSession,
} from "../utils/fhir-init-utils";

export const useFhirInitialization = () => {
  const dispatch = useAppDispatch();
  const fhirState = useAppSelector((state) => state.fhir);
  const { isInitialized, isInitializing } = fhirState;

  useEffect(() => {
    if (isInitialized || isInitializing) {
      return;
    }

    const runInitialization = async () => {
      try {
        await initializeFhirSession(dispatch, FHIR);
      } catch (error) {
        handleFhirInitializationFailure(dispatch, error);
      }
    };

    runInitialization();
  }, [dispatch, isInitialized, isInitializing]);

  return fhirState;
};
